import React, { FC } from 'react';

import { Stack } from '@mantine/core';

import { Component } from 'models';

import { Datasheet } from 'components/datasheet/Datasheet';
import { DatasheetMode } from 'components/datasheet/DatasheetMode';

import { Images } from './sections/Images';
import { Electrical, Files, General } from './sections/team';

type ComponentDatasheetProps = {
    component?: Component;
};

const ComponentDatasheet: FC<ComponentDatasheetProps> = () => {
    return (
        <Datasheet initialMode={DatasheetMode.EDIT}>
            <Stack gap={40} w="100%">
                <General />
                <Electrical />
                <Files />
                <Images />
            </Stack>
        </Datasheet>
    );
};

export { ComponentDatasheet };
